import { Select } from "@shopify/polaris";
import { FontStyles } from "../constants";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit/CustomInputWithUnit";
import FormSubSection from "./FormSubSection";
import NewCustomColorPicker from "../../../components/NewCustomColorPicker/NewCustomColorPicker";
import { Field } from "@shopify/react-form";

type DesignFreeGiftTypes = {
    dispatchBundleConfig: any;
    bundleType: string;
    cardName?: string;
    free_gift_header_bg_color?: Field<string> | null;
    free_gift_header_color?: Field<string> | null;
    free_gift_header_size?: Field<number> | null;
    free_gift_header_style?: Field<string> | null;
    free_gift_bg_color?: Field<string> | null;
    free_gift_text_style?: Field<string> | null;
    free_gift_text_size?: Field<number> | null;
    free_gift_text_color?: Field<string> | null;
    free_gift_border?: Field<boolean> | null;
    free_gift_border_width?: Field<number> | null;
    free_gift_border_color?: Field<string> | null;
};

const DesignFreeGift = ({
    dispatchBundleConfig,
    free_gift_header_bg_color,
    free_gift_header_color,
    free_gift_header_size,
    free_gift_header_style,
    free_gift_bg_color,
    free_gift_text_color,
    free_gift_text_size,
    free_gift_text_style,
}: DesignFreeGiftTypes) => {
    return (
        <div>
            {(free_gift_header_bg_color ||
                free_gift_header_color ||
                free_gift_header_size ||
                free_gift_header_style) && (
                <div id="free-gift-header">
                    <FormSubSection rowLabel={"Header"}>
                        {free_gift_header_bg_color && (
                            <NewCustomColorPicker
                                hexColor={free_gift_header_bg_color.value}
                                setHexColor={(val) => {
                                    free_gift_header_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_header_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...free_gift_header_bg_color,
                                    onBlur: () => free_gift_header_bg_color?.runValidation(),
                                }}
                            />
                        )}

                        {free_gift_header_color && (
                            <NewCustomColorPicker
                                hexColor={free_gift_header_color.value}
                                setHexColor={(val) => {
                                    free_gift_header_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_header_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...free_gift_header_color,
                                    onBlur: () => free_gift_header_color?.runValidation(),
                                }}
                            />
                        )}

                        {free_gift_header_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    free_gift_header_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_header_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={free_gift_header_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...free_gift_header_size,
                                    onBlur: () => free_gift_header_size?.runValidation(),
                                }}
                            />
                        )}
                        {free_gift_header_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    free_gift_header_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_header_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={free_gift_header_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(free_gift_bg_color || free_gift_text_color || free_gift_text_size || free_gift_text_style) && (
                <div id="free-gift-product">
                    <FormSubSection rowLabel={"Product"} hideSeparator={true}>
                        {free_gift_bg_color && (
                            <NewCustomColorPicker
                                hexColor={free_gift_bg_color.value}
                                setHexColor={(val) => {
                                    free_gift_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{ ...free_gift_bg_color, onBlur: () => free_gift_bg_color?.runValidation() }}
                            />
                        )}
                        {free_gift_text_color && (
                            <NewCustomColorPicker
                                hexColor={free_gift_text_color.value}
                                setHexColor={(val) => {
                                    free_gift_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...free_gift_text_color, onBlur: () => free_gift_text_color?.runValidation() }}
                            />
                        )}
                        {free_gift_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    free_gift_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={free_gift_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...free_gift_text_size,
                                    onBlur: () => free_gift_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {free_gift_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    free_gift_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            free_gift_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={free_gift_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
        </div>
    );
};

export default DesignFreeGift;
